import { formatDateProps } from "./format-date.types";

export const formatDate = (date: formatDateProps) => {
  const now = new Date(date);
  return now.toLocaleDateString("pt-BR");
};
